<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps #appSteps [steps]="[informationStep, reviewStep]" (onPrimary)="onSave()">
        <app-step
            #informationStep
            step="{{ 'employees.rehire.information' | translate }}"
            [stepForm]="informationForm"
            title="{{ 'employees.rehire.rehireDetails' | translate }}"
        >
            <app-employees-form-rehire-information
                #informationForm
                [employee]="employee"
                [rehireDetails]="rehireDetails"
            >
            </app-employees-form-rehire-information>
        </app-step>

        <app-step
            #reviewStep
            step="{{ 'employees.rehire.review' | translate }}"
            [stepForm]="reviewForm"
            title="{{ 'employees.rehire.review' | translate }}"
        >
            <app-employees-form-rehire-review #reviewForm [employee]="employee" [rehireDetails]="rehireDetails">
            </app-employees-form-rehire-review>
        </app-step>
    </app-steps>
</div>
